import React from "react";

import type { TAccessionDetail, TSample } from "@/lib/types";

type RequisitionContextValue = {
  accession: TAccessionDetail;
  labId: number;
  setLabId: React.Dispatch<React.SetStateAction<number>>;
  selectedSamples: number[];
  setSelectedSamples: React.Dispatch<React.SetStateAction<number[]>>;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  samples: TSample[];
};

const RequisitionContext = React.createContext({} as RequisitionContextValue);

export function RequisitionProvider({
  children,
  accession,
  samples,
  labId,
  setLabId,
}: {
  children: React.ReactNode;
  accession: TAccessionDetail;
  samples: TSample[];
  labId: number;
  setLabId: React.Dispatch<React.SetStateAction<number>>;
}) {
  const [selectedSamples, setSelectedSamples] = React.useState<number[]>(() => {
    return samples.map((sample) => sample.id);
  });

  const [loading, setLoading] = React.useState(false);

  return (
    <RequisitionContext.Provider
      value={{
        accession,
        labId,
        setLabId,
        selectedSamples,
        setSelectedSamples,
        loading,
        setLoading,
        samples,
      }}
    >
      {children}
    </RequisitionContext.Provider>
  );
}

export function useRequisition() {
  return React.useContext(RequisitionContext);
}
